<mapfre-card additionalClasses="error-page link_expire" [additionalSectionClasses]="'error-section'">
    <div class="row padding-top link_logo pt36 margin-bottom mb8">
      <div class="col">
        <ng-container *ngIf="isAcmic; else maForgotIcon">
          <img src="assets/SVG/icon-link-expire-acmic.svg" alt="warning icon"/>
        </ng-container>
        <ng-template #maForgotIcon>
          <svg-create-new-password-expired-svg></svg-create-new-password-expired-svg>
        </ng-template>
          
        </div>
    </div>
    <div class="row">
      <div class="col">
        <h1 class="title-copy text-center">{{ 'LINK_EXPIRED' | translate }}</h1>
      </div>
    </div>
    <div class="row subText text-center">
      <div class="col">
        <p class="color-class">{{ 'LINK_EXPIRED_TEXT' | translate }}</p>
      </div>
    </div>
    <div class="row margin-bottom mb24">
      <div class="col">
          <a routerLink="/login"  class="btn mapfre waves-light basic primary large"> {{'LOGIN' | translate}} </a> 
      </div>
    </div>
    <div class="row text-center">
      <div class="col">
        <a routerLink="/forgotpassword/">
          <ng-container *ngIf="isAcmic; else maButton">
            <mapfre-button 
            additionalClasses="link-button blue-link small"> {{'LINK_EXPIRED_FORGOT_PASS' | translate}} </mapfre-button>
          </ng-container>
          <ng-template #maButton>
            <mapfre-button 
            additionalClasses="waves-light ghost secondary large h40"> {{'LINK_EXPIRED_FORGOT_PASS' | translate}} </mapfre-button>
          </ng-template>          
        </a>
      </div>
    </div>
</mapfre-card>
  